// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import { CopiedRequestedDateRow } from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/RequestedDateState";

export type SetCopiedRequestedDateRowParameter = {
    copiedRow?: CopiedRequestedDateRow;
};

type HandlerType = Handler<SetCopiedRequestedDateRowParameter>;

export const DispatchSetCopiedRequestedDateRow: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/CartRequestedDate/SetCopiedRow",
        copiedRow: props.parameter.copiedRow,
    });
};

export const chain = [DispatchSetCopiedRequestedDateRow];

const setCopiedRequestedDateRow = createHandlerChainRunner(chain, "SetCopiedRequestedDateRow");

export default setCopiedRequestedDateRow;
